import { Box } from '@radix-ui/themes'

const QuestionTypeItem = ({ title }: { title: string }) => {
  return (
    <Box className='border-[#D5D7DA rouned-[8px] rounded-[8px] border bg-white px-2.5 py-1 font-normal shadow-[0_1px_2px_#023A7B0D]'>
      {title}
    </Box>
  )
}

export default QuestionTypeItem
